import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as CommunityActionCreators from '../../actions/community'

import CommunityAdmin from './CommunityAdmin'

class CommunityAdminContainer extends React.Component {
  static propTypes = {
    communities: PropTypes.object.isRequired,
    communityActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      communities: state.communities,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      communityActions: bindActionCreators(CommunityActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.props.communityActions.listCommunities()
  }

  render() {
    const { communities, communityActions } = this.props

    return (
      <CommunityAdmin
        communities={communities}
        onCreateCommunity={communityActions.addCommunity}
        onUpdateCommunity={communityActions.saveCommunity}
      />
    )
  }
}

export default connect(
  CommunityAdminContainer.mapStateToProps,
  CommunityAdminContainer.mapDispatchToProps,
)(CommunityAdminContainer)
